import React, { Component } from "react";
import { connect } from "react-redux";
import { getReport, getStandaloneReport } from "./actions";
import MapContainer from "../MapContainer";
import { StyledHeader } from "../../styles";
import {
    Card,
    CardContent,
    Button,
    Typography,
    Table,
    TableBody,
    TableRow,
} from "@material-ui/core";
import PrintIcon from "@material-ui/icons/Print";
import { selectCurrentReport } from "./selectors";
import ReactToPrint from "react-to-print";
import { gridStyle, cellStyle } from "../gridHelper";
import "../imgDiv.css";
import { noImg } from "vrcore-dashboard/dist/utilities";
import { Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

class CustomReport extends Component {
    constructor(props) {
        super(props);
        const path = props.location.pathname.split("/");
        if (path[2] === "reports") {
            props.getStandaloneReport(
                path[2].replace(/-/g, "_"),
                path[3],
                path[5].replace(/_/g, " ").replace(/\./g, ":"),
                path[4].replace(/-/g, "_")
            );
        } else {
            props.getReport(
                path[6],
                path[2].replace(/-/g, "_"),
                path[3],
                path[4].replace(/-/g, "_"),
                path[5].replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":"),
                path[7].replace(/-/g, "_")
            );
        }
        this.state = {
            reportRetrieved: false,
            report: [],
            imageModal: false,
            selectedImg: false,
        };
    }
    componentDidUpdate(prevState) {
        if (prevState.report !== this.props.report) {
            this.setState({ report: this.props.report });
        }
    }

    renderReps(attachedReps) {
        let repsRow = 3;
        let repsCell = 1;
        return attachedReps.map((rep, i) => {
            let repsInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cellStyle(
                            repsRow,
                            repsCell,
                            repsRow,
                            repsCell,
                            true
                        )}
                    >
                        {rep.name}
                    </div>
                    <div
                        style={cellStyle(
                            repsRow,
                            repsCell + 1,
                            repsRow,
                            repsCell + 1,
                            true
                        )}
                    >
                        {rep.organisation}
                    </div>
                </React.Fragment>
            );
            repsRow += 1;
            repsCell = 1;
            return repsInfo;
        });
    }

    renderContractors(attachedContractors) {
        let repsRow = 3;
        let repsCell = 1;
        return attachedContractors.map((contractor, i) => {
            let contractorInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cellStyle(
                            repsRow,
                            repsCell,
                            repsRow,
                            repsCell,
                            true
                        )}
                    >
                        {contractor.name}
                    </div>
                    <div
                        style={cellStyle(
                            repsRow,
                            repsCell + 1,
                            repsRow,
                            repsCell + 1,
                            true
                        )}
                    >
                        {contractor.type}
                    </div>
                </React.Fragment>
            );
            repsRow += 1;
            repsCell = 1;
            return contractorInfo;
        });
    }

    renderCirculation(attachedCirculation) {
        let repsRow = 3;
        let repsCell = 1;
        return attachedCirculation.map((circulation, i) => {
            let circulationInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cellStyle(
                            repsRow,
                            repsCell,
                            repsRow,
                            repsCell,
                            true
                        )}
                    >
                        {circulation.name}
                    </div>
                    <div
                        style={cellStyle(
                            repsRow,
                            repsCell + 1,
                            repsRow,
                            repsCell + 1,
                            true
                        )}
                    >
                        {circulation.email_address}
                    </div>
                </React.Fragment>
            );
            repsRow += 1;
            repsCell = 1;
            return circulationInfo;
        });
    }

    render() {
        const report = this.props.report === false ? [] : this.props.report;
        const cstyle = cellStyle;
        const gstyle = gridStyle;
        let color = this.props.color;
        return (
            <Card>
                  <StyledHeader style={{ background: "#0188cc" }}>
                <Typography variant="h5" style={{ color: "white" }}>
                        Inspection Report
               
                
                    <ReactToPrint
                        onBeforePrint={() => {
                            setTimeout(undefined, 2000);
                        }}
                        trigger={() => (
                            <PrintIcon
                                    style={{
                                        float: "right",
                                        fontSize: "36px",
                                        marginRight: "30px",
                                        cursor:"pointer"
                                    }}
                                    />
                        )}
                        content={() => this.componentRef}
                    />
                    </Typography>
                    </StyledHeader>
                    <CardContent>
                    {report && (
                        <div ref={(el) => (this.componentRef = el)}>
                            {this.props.header && (
                                <this.props.header
                                    date={this.props.match.params.report_id}
                                    reportType={this.props.reportType}
                                />
                            )}
                            <div style={{ width: "100%" }}>
                                <div style={{ width: "60%", float: "left" }}>
                                    <div style={gstyle(7, 13, null, color)}>
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Information</b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 7)}>
                                            <b>Name:</b>
                                        </div>
                                        <div style={cstyle(2, 7, 2, 13, true)}>
                                            {report.user_name
                                                ? report.user_name
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(3, 1, 3, 7)}>
                                            <b>Email:</b>
                                        </div>
                                        <div style={cstyle(3, 7, 3, 13, true)}>
                                            {report.user_email
                                                ? report.user_email
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(4, 1, 4, 13)}>
                                            <b>Form Created: </b>
                                        </div>
                                        <div style={cstyle(4, 7, 4, 13, true)}>
                                            {report.timestamp
                                                ? report.timestamp
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(5, 1, 5, 7)}>
                                            <b>Longitude: </b>
                                        </div>
                                        <div style={cstyle(5, 7, 5, 13, true)}>
                                            {report.location_lon
                                                ? report.location_lon
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(6, 1, 6, 7)}>
                                            <b>Latitude: </b>
                                        </div>
                                        <div style={cstyle(6, 7, 6, 13, true)}>
                                            {report.location_lat
                                                ? report.location_lat
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(7, 1, 7, 7)}>
                                            <b>Inspection Template: </b>
                                        </div>
                                        <div style={cstyle(7, 7, 7, 13, true)}>
                                            {report.config
                                                ? report.config
                                                : "N/A"}
                                        </div>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        width: "38%",
                                        float: "left",
                                        marginLeft: "2%",
                                    }}
                                >
                                    <MapContainer
                                        lat={+report.location_lat}
                                        long={+report.location_lon}
                                        style={{ width: "80%" }}
                                    />
                                    <br />
                                    <br />
                                </div>
                            </div>
                            <div style={{ display: "flex", clear: "both" }}>
                                <div
                                    style={{
                                        width: "50%",
                                        clear: "both",
                                        padding: "10px",
                                    }}
                                >
                                    <ExpansionPanel>
                                        <ExpansionPanelSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                            style={{
                                                backgroundColor: "#0188cc",
                                                borderRadius: "6px",
                                            }}
                                        >
                                            <h3
                                                style={{
                                                    textAlign: "center",
                                                    padding: "4px",
                                                    fontWeight: "bold",
                                                    color: "white",
                                                    borderRadius: "6px",
                                                    fontSize: "22px",
                                                }}
                                            >
                                                Section 1: Inspection Details
                                            </h3>
                                        </ExpansionPanelSummary>
                                        {report.project_id === null ||
                                        report.project_id === "N/A" ? (
                                            ""
                                        ) : (
                                            <>
                                                <div
                                                    style={{
                                                        border:
                                                            "2px solid #0188cc",
                                                        borderRadius: "6px",
                                                        marginLeft: "18px",
                                                        marginTop: "10px",
                                                        marginBottom: "10px",
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            marginBottom: "1px",
                                                            marginLeft: "56px",
                                                        }}
                                                    >
                                                        Project Id: &nbsp;{" "}
                                                        <b>
                                                            {report.project_id
                                                                ? report.project_id
                                                                : "N/A"}
                                                        </b>
                                                    </p>
                                                </div>
                                            </>
                                        )}

                                        {report.project_title === null ||
                                        report.project_title === "N/A" ? (
                                            ""
                                        ) : (
                                            <div
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "6px",
                                                    marginLeft: "18px",
                                                    marginTop: "10px",
                                                    marginBottom: "10px",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginBottom: "1px",
                                                        marginLeft: "56px",
                                                    }}
                                                >
                                                    Project Title: &nbsp;{" "}
                                                    <b>
                                                        {report.project_title
                                                            ? report.project_title
                                                            : "N/A"}
                                                    </b>
                                                </p>
                                            </div>
                                        )}

                                        {report.work_description === null ||
                                        report.work_description === "N/A" ? (
                                            ""
                                        ) : (
                                            <div
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "6px",
                                                    marginLeft: "18px",
                                                    marginTop: "10px",
                                                    marginBottom: "10px",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginBottom: "1px",
                                                        marginLeft: "56px",
                                                    }}
                                                >
                                                    Work Description: &nbsp;
                                                    <b>
                                                        {report.work_description
                                                            ? report.work_description
                                                            : "N?A"}
                                                    </b>
                                                </p>
                                            </div>
                                        )}

                                        {report.work_location === null ||
                                        report.work_location === "N/A" ? (
                                            ""
                                        ) : (
                                            <div
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "6px",
                                                    marginLeft: "18px",
                                                    marginTop: "10px",
                                                    marginBottom: "10px",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginBottom: "1px",
                                                        marginLeft: "56px",
                                                    }}
                                                >
                                                    Job Address: &nbsp;
                                                    <b>
                                                        {report.work_location
                                                            ? report.work_location
                                                            : "N/A"}
                                                    </b>
                                                </p>
                                            </div>
                                        )}

                                        {report.client === null ||
                                        report.client === "N/A" ? (
                                            ""
                                        ) : (
                                            <div
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "6px",
                                                    marginLeft: "18px",
                                                    marginTop: "10px",
                                                    marginBottom: "10px",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginBottom: "1px",
                                                        marginLeft: "56px",
                                                    }}
                                                >
                                                    Client: &nbsp;
                                                    <b>
                                                        {report.client
                                                            ? report.client
                                                            : "N/A"}
                                                    </b>
                                                </p>
                                            </div>
                                        )}

                                        {report.designer === null ||
                                        report.designer === "N/A" ? (
                                            ""
                                        ) : (
                                            <div
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "6px",
                                                    marginLeft: "18px",
                                                    marginTop: "10px",
                                                    marginBottom: "10px",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginBottom: "1px",
                                                        marginLeft: "56px",
                                                    }}
                                                >
                                                    Designer: &nbsp;
                                                    <b>
                                                        {report.designer
                                                            ? report.designer
                                                            : "N/A"}
                                                    </b>
                                                </p>
                                            </div>
                                        )}

                                        {report.main_contractor === null ||
                                        report.main_contractor === "N/A" ? (
                                            ""
                                        ) : (
                                            <div
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "6px",
                                                    marginLeft: "18px",
                                                    marginTop: "10px",
                                                    marginBottom: "10px",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginBottom: "1px",
                                                        marginLeft: "56px",
                                                    }}
                                                >
                                                    Main Contractor: &nbsp;
                                                    <b>
                                                        {report.main_contractor
                                                            ? report.main_contractor
                                                            : "N/A"}
                                                    </b>
                                                </p>
                                            </div>
                                        )}

                                        {report.psdp === null ||
                                        report.psdp === "N/A" ? (
                                            ""
                                        ) : (
                                            <div
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "6px",
                                                    marginLeft: "18px",
                                                    marginTop: "10px",
                                                    marginBottom: "10px",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginBottom: "1px",
                                                        marginLeft: "56px",
                                                    }}
                                                >
                                                    PSDP: &nbsp;
                                                    <b>
                                                        {report.psdp
                                                            ? report.psdp
                                                            : "N/A"}
                                                    </b>
                                                </p>
                                            </div>
                                        )}

                                        {report.pscs === null ||
                                        report.pscs === "N/A" ? (
                                            ""
                                        ) : (
                                            <div
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "6px",
                                                    marginLeft: "18px",
                                                    marginTop: "10px",
                                                    marginBottom: "10px",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginBottom: "1px",
                                                        marginLeft: "56px",
                                                    }}
                                                >
                                                    PSCS: &nbsp;
                                                    <b>
                                                        {report.pscs
                                                            ? report.pscs
                                                            : "N/A"}
                                                    </b>
                                                </p>
                                            </div>
                                        )}

                                        {report.weather_conditions === null ||
                                        report.weather_conditions === "N/A" ? (
                                            ""
                                        ) : (
                                            <>
                                                <div
                                                    style={{
                                                        border:
                                                            "2px solid #0188cc",
                                                        borderRadius: "6px",
                                                        marginLeft: "18px",
                                                        marginTop: "10px",
                                                        marginBottom: "10px",
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            marginBottom: "1px",
                                                            marginLeft: "56px",
                                                        }}
                                                    >
                                                        Weather Conditions:
                                                        &nbsp;
                                                        <b>
                                                            {report.weather_conditions
                                                                ? report.weather_conditions
                                                                : "N/A"}
                                                        </b>
                                                    </p>
                                                    {report.weather_conditions_photo_url ===
                                                        "" ||
                                                    report.weather_conditions_photo_url ===
                                                        "N/A" ? (
                                                        ""
                                                    ) : (
                                                        <div>
                                                            <div
                                                                style={gstyle(
                                                                    4,
                                                                    9,
                                                                    null,
                                                                    color
                                                                )}
                                                            >
                                                                <div
                                                                    style={cellStyle(
                                                                        1,
                                                                        1,
                                                                        1,
                                                                        1
                                                                    )}
                                                                >
                                                                    <img
                                                                        src={
                                                                            report.weather_conditions_photo_url
                                                                        }
                                                                        alt="Site "
                                                                        style={{
                                                                            width:
                                                                                "100px",
                                                                            height:
                                                                                "100px",
                                                                            margin:
                                                                                "auto",
                                                                            cursor:
                                                                                "pointer",
                                                                        }}
                                                                        onClick={() => {
                                                                            this.setState(
                                                                                {
                                                                                    imageModal: true,
                                                                                    selectedImg:
                                                                                        report.weather_conditions_photo_url,
                                                                                }
                                                                            );
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </>
                                        )}

                                        {report.light_conditions === null ||
                                        report.light_conditions === "N/A" ? (
                                            ""
                                        ) : (
                                            <>
                                                <div
                                                    style={{
                                                        border:
                                                            "2px solid #0188cc",
                                                        borderRadius: "6px",
                                                        marginLeft: "18px",
                                                        marginTop: "10px",
                                                        marginBottom: "10px",
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            marginBottom: "1px",
                                                            marginLeft: "56px",
                                                        }}
                                                    >
                                                        Light Conditions: &nbsp;
                                                        <b>
                                                            {report.light_conditions
                                                                ? report.light_conditions
                                                                : "N/A"}
                                                        </b>
                                                    </p>
                                                    {report.light_conditions_photo_url ===
                                                        "" ||
                                                    report.light_conditions_photo_url ===
                                                        "N/A" ? (
                                                        ""
                                                    ) : (
                                                        <div>
                                                            <div
                                                                style={gstyle(
                                                                    4,
                                                                    9,
                                                                    null,
                                                                    color
                                                                )}
                                                            >
                                                                <div
                                                                    style={cellStyle(
                                                                        1,
                                                                        1,
                                                                        1,
                                                                        1
                                                                    )}
                                                                >
                                                                    <img
                                                                        src={
                                                                            report.light_conditions_photo_url
                                                                        }
                                                                        alt="Site "
                                                                        style={{
                                                                            width:
                                                                                "100px",
                                                                            height:
                                                                                "100px",
                                                                            margin:
                                                                                "auto",
                                                                            cursor:
                                                                                "pointer",
                                                                        }}
                                                                        onClick={() => {
                                                                            this.setState(
                                                                                {
                                                                                    imageModal: true,
                                                                                    selectedImg:
                                                                                        report.light_conditions_photo_url,
                                                                                }
                                                                            );
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </>
                                        )}

                                        {report.visibility_conditions ===
                                            null ||
                                        report.visibility_conditions ===
                                            "N/A" ? (
                                            ""
                                        ) : (
                                            <>
                                                <div
                                                    style={{
                                                        border:
                                                            "2px solid #0188cc",
                                                        borderRadius: "6px",
                                                        marginLeft: "18px",
                                                        marginTop: "10px",
                                                        marginBottom: "10px",
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            marginBottom: "1px",
                                                            marginLeft: "56px",
                                                        }}
                                                    >
                                                        Visibility: &nbsp;
                                                        <b>
                                                            {report.visibility_conditions
                                                                ? report.visibility_conditions
                                                                : "N/A"}
                                                        </b>
                                                    </p>
                                                    {report.visibility_conditions_photo_url ===
                                                        "" ||
                                                    report.visibility_conditions_photo_url ===
                                                        "N/A" ? (
                                                        ""
                                                    ) : (
                                                        <div>
                                                            <div
                                                                style={gstyle(
                                                                    4,
                                                                    9,
                                                                    null,
                                                                    color
                                                                )}
                                                            >
                                                                <div
                                                                    style={cellStyle(
                                                                        1,
                                                                        1,
                                                                        1,
                                                                        1
                                                                    )}
                                                                >
                                                                    <img
                                                                        src={
                                                                            report.visibility_conditions_photo_url
                                                                        }
                                                                        alt="Site "
                                                                        style={{
                                                                            width:
                                                                                "100px",
                                                                            height:
                                                                                "100px",
                                                                            margin:
                                                                                "auto",
                                                                            cursor:
                                                                                "pointer",
                                                                        }}
                                                                        onClick={() => {
                                                                            this.setState(
                                                                                {
                                                                                    imageModal: true,
                                                                                    selectedImg:
                                                                                        report.light_conditions_photo_url,
                                                                                }
                                                                            );
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </>
                                        )}

                                        {report.surface_conditions === null ||
                                        report.surface_conditions === "N/A" ? (
                                            ""
                                        ) : (
                                            <>
                                                <div
                                                    style={{
                                                        border:
                                                            "2px solid #0188cc",
                                                        borderRadius: "6px",
                                                        marginLeft: "18px",
                                                        marginTop: "10px",
                                                        marginBottom: "10px",
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            marginBottom: "1px",
                                                            marginLeft: "56px",
                                                        }}
                                                    >
                                                        Surface Condition:
                                                        &nbsp;
                                                        <b>
                                                            {report.surface_conditions
                                                                ? report.surface_conditions
                                                                : "N/A"}
                                                        </b>
                                                    </p>
                                                    {report.surface_conditions_photo_url ===
                                                        "" ||
                                                    report.surface_conditions_photo_url ===
                                                        "N/A" ? (
                                                        ""
                                                    ) : (
                                                        <div>
                                                            <div
                                                                style={gstyle(
                                                                    4,
                                                                    9,
                                                                    null,
                                                                    color
                                                                )}
                                                            >
                                                                <div
                                                                    style={cellStyle(
                                                                        1,
                                                                        1,
                                                                        1,
                                                                        1
                                                                    )}
                                                                >
                                                                    <img
                                                                        src={
                                                                            report.surface_conditions_photo_url
                                                                        }
                                                                        alt="Site "
                                                                        style={{
                                                                            width:
                                                                                "100px",
                                                                            height:
                                                                                "100px",
                                                                            margin:
                                                                                "auto",
                                                                            cursor:
                                                                                "pointer",
                                                                        }}
                                                                        onClick={() => {
                                                                            this.setState(
                                                                                {
                                                                                    imageModal: true,
                                                                                    selectedImg:
                                                                                        report.surface_conditions_photo_url,
                                                                                }
                                                                            );
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </>
                                        )}

                                        {report.wctp_conditions === null ||
                                        report.wctp_conditions === "N/A" ? (
                                            ""
                                        ) : (
                                            <>
                                                <div
                                                    style={{
                                                        border:
                                                            "2px solid #0188cc",
                                                        borderRadius: "6px",
                                                        marginLeft: "18px",
                                                        marginTop: "10px",
                                                        marginBottom: "10px",
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            marginBottom: "1px",
                                                            marginLeft: "56px",
                                                        }}
                                                    >
                                                        Working Close To Public:
                                                        &nbsp;
                                                        <b>
                                                            {report.wctp_conditions
                                                                ? report.wctp_conditions
                                                                : "N/A"}
                                                        </b>
                                                    </p>
                                                    {report.wctp_conditions_photo_url ===
                                                        "" ||
                                                    report.wctp_conditions_photo_url ===
                                                        "N/A" ? (
                                                        ""
                                                    ) : (
                                                        <div>
                                                            <div
                                                                style={gstyle(
                                                                    4,
                                                                    9,
                                                                    null,
                                                                    color
                                                                )}
                                                            >
                                                                <div
                                                                    style={cellStyle(
                                                                        1,
                                                                        1,
                                                                        1,
                                                                        1
                                                                    )}
                                                                >
                                                                    <img
                                                                        src={
                                                                            report.wctp_conditions_photo_url
                                                                        }
                                                                        alt="Site "
                                                                        style={{
                                                                            width:
                                                                                "100px",
                                                                            height:
                                                                                "100px",
                                                                            margin:
                                                                                "auto",
                                                                            cursor:
                                                                                "pointer",
                                                                        }}
                                                                        onClick={() => {
                                                                            this.setState(
                                                                                {
                                                                                    imageModal: true,
                                                                                    selectedImg:
                                                                                        report.wctp_conditions_photo_url,
                                                                                }
                                                                            );
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </>
                                        )}

                                        {typeof report.inspection_reps ===
                                        "undefined" ? (
                                            ""
                                        ) : (
                                            <div
                                                style={gstyle(
                                                    4,
                                                    9,
                                                    null,
                                                    color
                                                )}
                                            >
                                                <div
                                                    style={cstyle(
                                                        1,
                                                        1,
                                                        1,
                                                        1,
                                                        false,
                                                        true
                                                    )}
                                                >
                                                    <b>Inspection Reps</b>
                                                </div>
                                                <div
                                                    style={cstyle(
                                                        2,
                                                        1,
                                                        2,
                                                        1,
                                                        false,
                                                        false
                                                    )}
                                                >
                                                    <b>Name</b>
                                                </div>
                                                <div
                                                    style={cstyle(
                                                        2,
                                                        2,
                                                        2,
                                                        2,
                                                        false,
                                                        false
                                                    )}
                                                >
                                                    <b>Organisation</b>
                                                </div>
                                                {report.inspection_reps &&
                                                    this.renderReps(
                                                        report.inspection_reps
                                                    )}
                                            </div>
                                        )}

                                        {typeof report.sub_contractors ===
                                        "undefined" ? (
                                            ""
                                        ) : (
                                            <div
                                                style={gstyle(
                                                    4,
                                                    9,
                                                    null,
                                                    color
                                                )}
                                            >
                                                <div
                                                    style={cstyle(
                                                        1,
                                                        1,
                                                        1,
                                                        1,
                                                        false,
                                                        true
                                                    )}
                                                >
                                                    <b>Sub-Contractors</b>
                                                </div>
                                                <div
                                                    style={cstyle(
                                                        2,
                                                        1,
                                                        2,
                                                        1,
                                                        false,
                                                        false
                                                    )}
                                                >
                                                    <b>Name</b>
                                                </div>
                                                <div
                                                    style={cstyle(
                                                        2,
                                                        2,
                                                        2,
                                                        2,
                                                        false,
                                                        false
                                                    )}
                                                >
                                                    <b>Type</b>
                                                </div>
                                                {report.sub_contractors &&
                                                    this.renderContractors(
                                                        report.sub_contractors
                                                    )}
                                            </div>
                                        )}

                                        {typeof report.external_circulation ===
                                        "undefined" ? (
                                            ""
                                        ) : (
                                            <div
                                                style={gstyle(
                                                    4,
                                                    9,
                                                    null,
                                                    color
                                                )}
                                            >
                                                <div
                                                    style={cstyle(
                                                        1,
                                                        1,
                                                        1,
                                                        1,
                                                        false,
                                                        true
                                                    )}
                                                >
                                                    <b>External Circulation</b>
                                                </div>
                                                <div
                                                    style={cstyle(
                                                        2,
                                                        1,
                                                        2,
                                                        1,
                                                        false,
                                                        false
                                                    )}
                                                >
                                                    <b>Name</b>
                                                </div>
                                                <div
                                                    style={cstyle(
                                                        2,
                                                        2,
                                                        2,
                                                        2,
                                                        false,
                                                        false
                                                    )}
                                                >
                                                    <b>Email Address</b>
                                                </div>
                                                {report.external_circulation &&
                                                    this.renderCirculation(
                                                        report.external_circulation
                                                    )}
                                            </div>
                                        )}
                                    </ExpansionPanel>
                                </div>
                                <br />
                                <div
                                    style={{
                                        width: "50%",
                                        padding: "10px",
                                        marginLeft: "5px",
                                    }}
                                >
                                    <ExpansionPanel>
                                        <ExpansionPanelSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                            style={{
                                                backgroundColor: "#0188cc",
                                                borderRadius: "6px",
                                                fontSize: "22px",
                                            }}
                                        >
                                            <h3
                                                style={{
                                                    textAlign: "center",
                                                    padding: "4px",
                                                    fontWeight: "bold",
                                                    color: "white",
                                                    borderRadius: "6px",
                                                    fontSize: "22px",
                                                }}
                                            >
                                                Section 2: Work Details
                                            </h3>
                                        </ExpansionPanelSummary>
                                        {report.est_man_hours_total === null ||
                                        report.est_man_hours_total === "N/A" ? (
                                            ""
                                        ) : (
                                            <div
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "6px",
                                                    marginLeft: "18px",
                                                    marginTop: "10px",
                                                    marginBottom: "10px",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginBottom: "1px",
                                                        marginLeft: "56px",
                                                    }}
                                                >
                                                    Estimated Man Hours(This
                                                    Period Total): &nbsp;{" "}
                                                    <b>
                                                        {report.est_man_hours_total
                                                            ? report.est_man_hours_total
                                                            : "N/A"}
                                                    </b>
                                                </p>
                                            </div>
                                        )}

                                        {report.est_man_hours_works_cumulative ===
                                            null ||
                                        report.est_man_hours_works_cumulative ===
                                            "N/A" ? (
                                            ""
                                        ) : (
                                            <div
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "6px",
                                                    marginLeft: "18px",
                                                    marginTop: "10px",
                                                    marginBottom: "10px",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginBottom: "1px",
                                                        marginLeft: "56px",
                                                    }}
                                                >
                                                    Estimated Man Hours(Works
                                                    Cumulative Total): &nbsp;{" "}
                                                    <b>
                                                        {report.est_man_hours_works_cumulative
                                                            ? report.est_man_hours_works_cumulative
                                                            : "N/A"}
                                                    </b>
                                                </p>
                                            </div>
                                        )}

                                        {report.est_supervision_hours_total ===
                                            null ||
                                        report.est_supervision_hours_total ===
                                            "N/A" ? (
                                            ""
                                        ) : (
                                            <div
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "6px",
                                                    marginLeft: "18px",
                                                    marginTop: "10px",
                                                    marginBottom: "10px",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginBottom: "1px",
                                                        marginLeft: "56px",
                                                    }}
                                                >
                                                    Estimated Supervision
                                                    Hours(This Period Total):
                                                    &nbsp;{" "}
                                                    <b>
                                                        {report.est_supervision_hours_total
                                                            ? report.est_supervision_hours_total
                                                            : "N/A"}
                                                    </b>
                                                </p>
                                            </div>
                                        )}

                                        {report.est_supervision_hours_works_cumulative ===
                                            null ||
                                        report.est_supervision_hours_works_cumulative ===
                                            "N/A" ? (
                                            ""
                                        ) : (
                                            <div
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "6px",
                                                    marginLeft: "18px",
                                                    marginTop: "10px",
                                                    marginBottom: "10px",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginBottom: "1px",
                                                        marginLeft: "56px",
                                                    }}
                                                >
                                                    Estimated Supervision
                                                    Hours(Works Cumulative
                                                    Total): &nbsp;{" "}
                                                    <b>
                                                        {report.est_supervision_hours_works_cumulative
                                                            ? report.est_supervision_hours_works_cumulative
                                                            : "N/A"}
                                                    </b>
                                                </p>
                                            </div>
                                        )}

                                        {report.worker_health_summary ===
                                            null ||
                                        report.worker_health_summary ===
                                            "N/A" ? (
                                            ""
                                        ) : (
                                            <div
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "6px",
                                                    marginLeft: "18px",
                                                    marginTop: "10px",
                                                    marginBottom: "10px",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginBottom: "1px",
                                                        marginLeft: "56px",
                                                    }}
                                                >
                                                    Worker health Summary:
                                                    &nbsp;
                                                    <b>
                                                        {report.worker_health_summary
                                                            ? report.worker_health_summary
                                                            : "N/A"}
                                                    </b>
                                                </p>
                                            </div>
                                        )}

                                        {report.weeks_since_last_incident ===
                                            null ||
                                        report.weeks_since_last_incident ===
                                            "N/A" ? (
                                            ""
                                        ) : (
                                            <div
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "6px",
                                                    marginLeft: "18px",
                                                    marginTop: "10px",
                                                    marginBottom: "10px",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginBottom: "1px",
                                                        marginLeft: "56px",
                                                    }}
                                                >
                                                    Weeks Since Last Incident:
                                                    &nbsp;
                                                    <b>
                                                        {report.weeks_since_last_incident
                                                            ? report.weeks_since_last_incident
                                                            : "N/A"}
                                                    </b>
                                                </p>
                                            </div>
                                        )}

                                        {report.first_aid_incident === null ||
                                        report.first_aid_incident === "N/A" ? (
                                            ""
                                        ) : (
                                            <div
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "6px",
                                                    marginLeft: "18px",
                                                    marginTop: "10px",
                                                    marginBottom: "10px",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginBottom: "1px",
                                                        marginLeft: "56px",
                                                    }}
                                                >
                                                    First Aid Incident: &nbsp;
                                                    <b>
                                                        {report.first_aid_incident
                                                            ? report.first_aid_incident
                                                            : "N/A"}
                                                    </b>
                                                </p>
                                            </div>
                                        )}

                                        {report.sswp_toolbox_talk_status ===
                                            null ||
                                        report.sswp_toolbox_talk_status ===
                                            "N/A" ? (
                                            ""
                                        ) : (
                                            <div
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "6px",
                                                    marginLeft: "18px",
                                                    marginTop: "10px",
                                                    marginBottom: "10px",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginBottom: "1px",
                                                        marginLeft: "56px",
                                                    }}
                                                >
                                                    SSWP/Toolbox Talks Status:
                                                    &nbsp;
                                                    <b>
                                                        {report.sswp_toolbox_talk_status
                                                            ? report.sswp_toolbox_talk_status
                                                            : "N/A"}
                                                    </b>
                                                </p>
                                            </div>
                                        )}

                                        {report.ppe_status === null ||
                                        report.ppe_status === "N/A" ? (
                                            ""
                                        ) : (
                                            <div
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "6px",
                                                    marginLeft: "18px",
                                                    marginTop: "10px",
                                                    marginBottom: "10px",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginBottom: "1px",
                                                        marginLeft: "56px",
                                                    }}
                                                >
                                                    PPE Status: &nbsp;
                                                    <b>
                                                        {report.ppe_status
                                                            ? report.ppe_status
                                                            : "N/A"}
                                                    </b>
                                                </p>
                                            </div>
                                        )}

                                        {report.safety_enforcement === null ||
                                        report.safety_enforcement === "N/A" ? (
                                            ""
                                        ) : (
                                            <div
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "6px",
                                                    marginLeft: "18px",
                                                    marginTop: "10px",
                                                    marginBottom: "10px",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginBottom: "1px",
                                                        marginLeft: "56px",
                                                    }}
                                                >
                                                    Safety Enforcement: &nbsp;
                                                    <b>
                                                        {report.safety_enforcement
                                                            ? report.safety_enforcement
                                                            : "N/A"}
                                                    </b>
                                                </p>
                                            </div>
                                        )}

                                        {report.visitor_records === null ||
                                        report.visitor_records === "N/A" ? (
                                            ""
                                        ) : (
                                            <div
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "6px",
                                                    marginLeft: "18px",
                                                    marginTop: "10px",
                                                    marginBottom: "10px",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginBottom: "1px",
                                                        marginLeft: "56px",
                                                    }}
                                                >
                                                    Visitor Records: &nbsp;
                                                    <b>
                                                        {report.visitor_records
                                                            ? report.visitor_records
                                                            : "N/A"}
                                                    </b>
                                                </p>
                                            </div>
                                        )}

                                        {report.pending_hazardous_activities ===
                                            null ||
                                        report.pending_hazardous_activities ===
                                            "N/A" ? (
                                            ""
                                        ) : (
                                            <div
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "6px",
                                                    marginLeft: "18px",
                                                    marginTop: "10px",
                                                    marginBottom: "10px",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginBottom: "1px",
                                                        marginLeft: "56px",
                                                    }}
                                                >
                                                    Pending Hazardous
                                                    Activities: &nbsp;
                                                    <b>
                                                        {report.pending_hazardous_activities
                                                            ? report.pending_hazardous_activities
                                                            : "N/A"}
                                                    </b>
                                                </p>
                                            </div>
                                        )}

                                        {report.hsqe_summary === null ||
                                        report.hsqe_summary === "N/A" ? (
                                            ""
                                        ) : (
                                            <div
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "6px",
                                                    marginLeft: "18px",
                                                    marginTop: "10px",
                                                    marginBottom: "10px",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginBottom: "1px",
                                                        marginLeft: "56px",
                                                    }}
                                                >
                                                    HSQE Summary: &nbsp;
                                                    <b>
                                                        {report.hsqe_summary
                                                            ? report.hsqe_summary
                                                            : "N/A"}
                                                    </b>
                                                </p>
                                            </div>
                                        )}

                                        {report.incident_summary === null ||
                                        report.incident_summary === "N/A" ? (
                                            ""
                                        ) : (
                                            <>
                                                <div
                                                    style={{
                                                        border:
                                                            "2px solid #0188cc",
                                                        borderRadius: "6px",
                                                        marginLeft: "18px",
                                                        marginTop: "10px",
                                                        marginBottom: "10px",
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            marginBottom: "1px",
                                                            marginLeft: "56px",
                                                        }}
                                                    >
                                                        Incident Summary: &nbsp;
                                                        <b>
                                                            {report.incident_summary
                                                                ? report.incident_summary
                                                                : "N/A"}
                                                        </b>
                                                    </p>
                                                    {report.incident_summary_photo_url ===
                                                        "" ||
                                                    report.incident_summary_photo_url ===
                                                        "N/A" ? (
                                                        ""
                                                    ) : (
                                                        <div>
                                                            <div
                                                                style={gstyle(
                                                                    4,
                                                                    9,
                                                                    null,
                                                                    color
                                                                )}
                                                            >
                                                                <div
                                                                    style={cellStyle(
                                                                        1,
                                                                        1,
                                                                        1,
                                                                        1
                                                                    )}
                                                                >
                                                                    <img
                                                                        src={
                                                                            report.incident_summary_photo_url
                                                                        }
                                                                        alt="Site "
                                                                        style={{
                                                                            width:
                                                                                "100px",
                                                                            height:
                                                                                "100px",
                                                                            margin:
                                                                                "auto",
                                                                            cursor:
                                                                                "pointer",
                                                                        }}
                                                                        onClick={() => {
                                                                            this.setState(
                                                                                {
                                                                                    imageModal: true,
                                                                                    selectedImg:
                                                                                        report.incident_summary_photo_url,
                                                                                }
                                                                            );
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </>
                                        )}
                                    </ExpansionPanel>
                                </div>
                            </div>
                            <ExpansionPanel>
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                    style={{
                                        backgroundColor: "#0188cc",
                                        borderRadius: "6px",
                                        fontSize: "22px",
                                    }}
                                >
                                    <h3
                                        style={{
                                            textAlign: "center",
                                            padding: "4px",
                                            fontWeight: "bold",
                                            color: "white",
                                            borderRadius: "6px",
                                            fontSize: "22px",
                                        }}
                                    >
                                        Section 3: Inspection Items
                                    </h3>
                                </ExpansionPanelSummary>
                                <div>
                                    <Table>
                                        <TableBody>
                                            {report.groups &&
                                                report.groups.map((e, i) => {
                                                    return (
                                                        <TableRow key={i}>
                                                            <div
                                                                className="icon-text-container"
                                                                style={{
                                                                    borderWidth:
                                                                        "medium",
                                                                    border:
                                                                        "7px solid #0188cc",
                                                                    borderRadius:
                                                                        "9px",
                                                                    marginTop:
                                                                        "10px",
                                                                }}
                                                            >
                                                                <p
                                                                    style={{
                                                                        textAlign:
                                                                            "center",
                                                                        backgroundColor:
                                                                            "#c7c7cc",
                                                                        marginTop:
                                                                            "5px",
                                                                        paddingTop:
                                                                            "4px",
                                                                        paddingBottom:
                                                                            "4px",
                                                                        fontWeight:
                                                                            "bold",
                                                                    }}
                                                                >
                                                                    Group Name:{" "}
                                                                    {
                                                                        e
                                                                            .profile
                                                                            .group_name
                                                                    }
                                                                </p>
                                                                <div>
                                                                    <div>
                                                                        <h5
                                                                            style={{
                                                                                padding:
                                                                                    "7px",
                                                                                textAlign:
                                                                                    "left",
                                                                                fontSize:
                                                                                    "1em",
                                                                            }}
                                                                        >
                                                                            <b>
                                                                                Group
                                                                                Name:
                                                                            </b>{" "}
                                                                            <span className="subHeading">
                                                                                {
                                                                                    e
                                                                                        .profile
                                                                                        .group_name
                                                                                }
                                                                            </span>
                                                                        </h5>
                                                                    </div>
                                                                    <div>
                                                                        <h5
                                                                            style={{
                                                                                padding:
                                                                                    "7px",
                                                                                textAlign:
                                                                                    "left",
                                                                                fontSize:
                                                                                    "1em",
                                                                            }}
                                                                        >
                                                                            <b>
                                                                                Group
                                                                                Weight:
                                                                            </b>{" "}
                                                                            <span className="subHeading">
                                                                                {
                                                                                    e
                                                                                        .profile
                                                                                        .group_weight
                                                                                }
                                                                            </span>
                                                                        </h5>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <p
                                                                        style={{
                                                                            textAlign:
                                                                                "center",
                                                                            backgroundColor:
                                                                                "#c7c7cc",
                                                                            paddingTop:
                                                                                "4px",
                                                                            paddingBottom:
                                                                                "4px",
                                                                            fontWeight:
                                                                                "bold",
                                                                        }}
                                                                    >
                                                                        Item
                                                                        List
                                                                    </p>
                                                                    {e.items &&
                                                                        e.items.map(
                                                                            (
                                                                                k,
                                                                                j
                                                                            ) => {
                                                                                return (
                                                                                    <Row
                                                                                        key={
                                                                                            j
                                                                                        }
                                                                                        style={{
                                                                                            marginLeft:
                                                                                                "auto",
                                                                                        }}
                                                                                    >
                                                                                        <div
                                                                                            className="icon-text-container"
                                                                                            style={{
                                                                                                borderWidth:
                                                                                                    "medium",
                                                                                                border:
                                                                                                    "2px solid #0188cc",
                                                                                                borderRadius:
                                                                                                    "9px",
                                                                                                margin:
                                                                                                    "10px",
                                                                                                width:
                                                                                                    "700px",
                                                                                            }}
                                                                                        >
                                                                                            <p
                                                                                                style={{
                                                                                                    marginLeft:
                                                                                                        "10px",
                                                                                                }}
                                                                                            >
                                                                                                <b>
                                                                                                    Item
                                                                                                    Name:&nbsp;
                                                                                                </b>
                                                                                                {
                                                                                                    k.item_name
                                                                                                }
                                                                                            </p>
                                                                                            <div
                                                                                                className="icon-text-container"
                                                                                                style={{
                                                                                                    borderWidth:
                                                                                                        "medium",
                                                                                                    marginTop:
                                                                                                        "10px",
                                                                                                    marginLeft:
                                                                                                        "10px",
                                                                                                    marginRight:
                                                                                                        "10px",
                                                                                                    marginBottom:
                                                                                                        "10px",
                                                                                                    display:
                                                                                                        "flex",
                                                                                                }}
                                                                                            >
                                                                                                <p
                                                                                                    style={{
                                                                                                        marginLeft:
                                                                                                            "25px",
                                                                                                    }}
                                                                                                >
                                                                                                    <b>
                                                                                                        Item
                                                                                                        Weight:&nbsp;
                                                                                                    </b>
                                                                                                    {
                                                                                                        k.item_weight
                                                                                                    }
                                                                                                </p>
                                                                                                <p
                                                                                                    style={{
                                                                                                        marginLeft:
                                                                                                            "25px",
                                                                                                    }}
                                                                                                >
                                                                                                    <b>
                                                                                                        Item
                                                                                                        Class:&nbsp;
                                                                                                    </b>{" "}
                                                                                                    {
                                                                                                        k.item_response_class
                                                                                                    }
                                                                                                </p>

                                                                                                <p
                                                                                                    style={{
                                                                                                        marginLeft:
                                                                                                            "25px",
                                                                                                    }}
                                                                                                >
                                                                                                    <b>
                                                                                                        Result:&nbsp;
                                                                                                    </b>{" "}
                                                                                                    {
                                                                                                        k.item_status
                                                                                                    }
                                                                                                </p>
                                                                                                <div className="clear"></div>
                                                                                            </div>

                                                                                            {report.attached_photos &&
                                                                                                report.attached_photos.map(
                                                                                                    (
                                                                                                        z
                                                                                                    ) => {
                                                                                                        let groupImageRef = `${e.profile.group_id}`;
                                                                                                        var itemImageRef = `${k.item_id}`;
                                                                                                        groupImageRef =
                                                                                                            parseInt(
                                                                                                                groupImageRef
                                                                                                            ) +
                                                                                                            1;
                                                                                                        let final = `Group ${groupImageRef}\\nItem ${itemImageRef}`;
                                                                                                        if (
                                                                                                            z.photo_name.replace(
                                                                                                                /\n/,
                                                                                                                "\\n"
                                                                                                            ) ===
                                                                                                            final
                                                                                                        ) {
                                                                                                            return (
                                                                                                                <>
                                                                                                                    <div
                                                                                                                        style={gstyle(
                                                                                                                            4,
                                                                                                                            9,
                                                                                                                            null,
                                                                                                                            color
                                                                                                                        )}
                                                                                                                    >
                                                                                                                        <div
                                                                                                                            style={cellStyle(
                                                                                                                                1,
                                                                                                                                1,
                                                                                                                                1,
                                                                                                                                1
                                                                                                                            )}
                                                                                                                        >
                                                                                                                            <img
                                                                                                                                src={
                                                                                                                                    z.photo_url
                                                                                                                                }
                                                                                                                                alt="Site "
                                                                                                                                style={{
                                                                                                                                    width:
                                                                                                                                        "100px",
                                                                                                                                    height:
                                                                                                                                        "100px",
                                                                                                                                    margin:
                                                                                                                                        "auto",
                                                                                                                                    cursor:
                                                                                                                                        "pointer",
                                                                                                                                }}
                                                                                                                                onClick={() => {
                                                                                                                                    this.setState(
                                                                                                                                        {
                                                                                                                                            imageModal: true,
                                                                                                                                            selectedImg:
                                                                                                                                                z.photo_url,
                                                                                                                                        }
                                                                                                                                    );
                                                                                                                                }}
                                                                                                                            />
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </>
                                                                                                            );
                                                                                                        } else {
                                                                                                            return null;
                                                                                                        }
                                                                                                    }
                                                                                                )}

                                                                                            {k.item_status ===
                                                                                                "Green" ||
                                                                                            k.item_status ===
                                                                                                "N/A" ? (
                                                                                                ""
                                                                                            ) : (
                                                                                                <>
                                                                                                    <div>
                                                                                                        <p
                                                                                                            style={{
                                                                                                                marginLeft:
                                                                                                                    "10px",
                                                                                                            }}
                                                                                                        >
                                                                                                            <b>
                                                                                                                Issue:&nbsp;
                                                                                                            </b>
                                                                                                            {
                                                                                                                k.issue
                                                                                                            }
                                                                                                        </p>
                                                                                                        <p
                                                                                                            style={{
                                                                                                                marginLeft:
                                                                                                                    "10px",
                                                                                                            }}
                                                                                                        >
                                                                                                            <b>
                                                                                                                Consider
                                                                                                                Action:&nbsp;
                                                                                                            </b>
                                                                                                            {
                                                                                                                k.consider_action
                                                                                                            }
                                                                                                        </p>
                                                                                                    </div>
                                                                                                    <div
                                                                                                        className="icon-text-container"
                                                                                                        style={{
                                                                                                            borderWidth:
                                                                                                                "medium",
                                                                                                            margin:
                                                                                                                "10px",
                                                                                                            display:
                                                                                                                "flex",
                                                                                                        }}
                                                                                                    >
                                                                                                        <p>
                                                                                                            <b>
                                                                                                                Response
                                                                                                                Date:&nbsp;
                                                                                                            </b>
                                                                                                            {
                                                                                                                k.response_date
                                                                                                            }
                                                                                                        </p>
                                                                                                        <p
                                                                                                            style={{
                                                                                                                marginLeft:
                                                                                                                    "25px",
                                                                                                            }}
                                                                                                        >
                                                                                                            <b>
                                                                                                                Assigned
                                                                                                                To:&nbsp;
                                                                                                            </b>{" "}
                                                                                                            {
                                                                                                                k.assigned_to
                                                                                                            }
                                                                                                        </p>
                                                                                                        <div className="clear"></div>
                                                                                                    </div>
                                                                                                </>
                                                                                            )}
                                                                                            {k.assigned_to ===
                                                                                            "" ? (
                                                                                                ""
                                                                                            ) : (
                                                                                                <>
                                                                                                    <div
                                                                                                        className="icon-text-container"
                                                                                                        style={{
                                                                                                            borderWidth:
                                                                                                                "medium",
                                                                                                            margin:
                                                                                                                "10px",
                                                                                                        }}
                                                                                                    >
                                                                                                        <p>
                                                                                                            <b>
                                                                                                                Action
                                                                                                                Taken:&nbsp;
                                                                                                            </b>
                                                                                                            {typeof k.action_taken ===
                                                                                                            "undefined"
                                                                                                                ? ""
                                                                                                                : k.action_taken}
                                                                                                        </p>
                                                                                                        {report.attached_photos &&
                                                                                                            report.attached_photos.map(
                                                                                                                (
                                                                                                                    actionPhoto
                                                                                                                ) => {
                                                                                                                    let groupImageRef = `${e.profile.group_id}`;
                                                                                                                    var itemImageRef = `${k.item_id}`;
                                                                                                                    groupImageRef =
                                                                                                                        parseInt(
                                                                                                                            groupImageRef
                                                                                                                        ) +
                                                                                                                        1;
                                                                                                                    let reference = `Action\\nGroup ${groupImageRef}\\nItem ${itemImageRef}`;
                                                                                                                    var actionPhotoRef = actionPhoto.photo_name.replace(
                                                                                                                        /\n/,
                                                                                                                        "\\n"
                                                                                                                    );
                                                                                                                    var actionPhotoReference = actionPhotoRef.replace(
                                                                                                                        /\n/,
                                                                                                                        "\\n"
                                                                                                                    );
                                                                                                                    if (
                                                                                                                        actionPhotoReference ===
                                                                                                                        reference
                                                                                                                    ) {
                                                                                                                        return (
                                                                                                                            <>
                                                                                                                                <div
                                                                                                                                    style={gstyle(
                                                                                                                                        4,
                                                                                                                                        9,
                                                                                                                                        null,
                                                                                                                                        color
                                                                                                                                    )}
                                                                                                                                >
                                                                                                                                    <div
                                                                                                                                        style={cellStyle(
                                                                                                                                            1,
                                                                                                                                            1,
                                                                                                                                            1,
                                                                                                                                            1
                                                                                                                                        )}
                                                                                                                                    >
                                                                                                                                        <img
                                                                                                                                            src={
                                                                                                                                                actionPhoto.photo_url
                                                                                                                                            }
                                                                                                                                            alt="Site "
                                                                                                                                            style={{
                                                                                                                                                width:
                                                                                                                                                    "100px",
                                                                                                                                                height:
                                                                                                                                                    "100px",
                                                                                                                                                margin:
                                                                                                                                                    "auto",
                                                                                                                                                cursor:
                                                                                                                                                    "pointer",
                                                                                                                                            }}
                                                                                                                                            onClick={() => {
                                                                                                                                                this.setState(
                                                                                                                                                    {
                                                                                                                                                        imageModal: true,
                                                                                                                                                        selectedImg:
                                                                                                                                                            actionPhoto.photo_url,
                                                                                                                                                    }
                                                                                                                                                );
                                                                                                                                            }}
                                                                                                                                        />
                                                                                                                                    </div>
                                                                                                                                </div>
                                                                                                                            </>
                                                                                                                        );
                                                                                                                    } else {
                                                                                                                        return null;
                                                                                                                    }
                                                                                                                }
                                                                                                            )}
                                                                                                        <p>
                                                                                                            <b>
                                                                                                                Item
                                                                                                                Close
                                                                                                                Date:&nbsp;
                                                                                                            </b>
                                                                                                            {typeof k.item_close_date ===
                                                                                                            "undefined"
                                                                                                                ? ""
                                                                                                                : k.item_close_date}
                                                                                                        </p>
                                                                                                        <div className="clear"></div>
                                                                                                    </div>
                                                                                                </>
                                                                                            )}
                                                                                        </div>
                                                                                    </Row>
                                                                                );
                                                                            }
                                                                        )}
                                                                </div>
                                                                <div>
                                                                    {e.group_grade ===
                                                                    "Pass" ? (
                                                                        <div
                                                                            style={{
                                                                                display:
                                                                                    "flex",
                                                                                backgroundColor:
                                                                                    "green",
                                                                                color:
                                                                                    "white",
                                                                                marginBottom:
                                                                                    "5px",
                                                                            }}
                                                                        >
                                                                            <span>
                                                                                <h5
                                                                                    style={{
                                                                                        padding:
                                                                                            "7px",
                                                                                        fontSize:
                                                                                            "1em",
                                                                                        textAlign:
                                                                                            "left",
                                                                                        width:
                                                                                            "112px",
                                                                                        marginLeft:
                                                                                            "5px",
                                                                                    }}
                                                                                >
                                                                                    <b>
                                                                                        Summary
                                                                                    </b>
                                                                                </h5>
                                                                            </span>

                                                                            <span>
                                                                                <h5
                                                                                    style={{
                                                                                        fontSize:
                                                                                            "1em",
                                                                                        padding:
                                                                                            "7px",
                                                                                        textAlign:
                                                                                            "left",
                                                                                        width:
                                                                                            "206px",
                                                                                        marginLeft:
                                                                                            "5px",
                                                                                    }}
                                                                                >
                                                                                    <b>
                                                                                        Group
                                                                                        Status:
                                                                                    </b>{" "}
                                                                                    <span className="subHeading">
                                                                                        {
                                                                                            e.group_status
                                                                                        }
                                                                                    </span>
                                                                                </h5>
                                                                            </span>

                                                                            <span>
                                                                                <h5
                                                                                    style={{
                                                                                        fontSize:
                                                                                            "1em",
                                                                                        padding:
                                                                                            "7px",
                                                                                        textAlign:
                                                                                            "left",
                                                                                        width:
                                                                                            "206px",
                                                                                        marginLeft:
                                                                                            "5px",
                                                                                    }}
                                                                                >
                                                                                    <b>
                                                                                        Group
                                                                                        Mark:
                                                                                    </b>{" "}
                                                                                    <span className="subHeading">
                                                                                        {
                                                                                            e.group_mark
                                                                                        }
                                                                                    </span>
                                                                                </h5>
                                                                            </span>

                                                                            <span>
                                                                                <h5
                                                                                    style={{
                                                                                        fontSize:
                                                                                            "1em",
                                                                                        padding:
                                                                                            "7px",
                                                                                        textAlign:
                                                                                            "left",
                                                                                        width:
                                                                                            "300px",
                                                                                        marginLeft:
                                                                                            "5px",
                                                                                    }}
                                                                                >
                                                                                    <b>
                                                                                        Group
                                                                                        Outcome:
                                                                                    </b>{" "}
                                                                                    <span className="subHeading">
                                                                                        {
                                                                                            e.group_grade
                                                                                        }
                                                                                    </span>
                                                                                </h5>
                                                                            </span>
                                                                        </div>
                                                                    ) : e.group_grade ===
                                                                      "Fail" ? (
                                                                        <div
                                                                            style={{
                                                                                display:
                                                                                    "flex",
                                                                                backgroundColor:
                                                                                    "red",
                                                                                color:
                                                                                    "white",
                                                                                marginBottom:
                                                                                    "5px",
                                                                            }}
                                                                        >
                                                                            <span>
                                                                                <h5
                                                                                    style={{
                                                                                        fontSize:
                                                                                            "1em",
                                                                                        padding:
                                                                                            "7px",
                                                                                        textAlign:
                                                                                            "left",
                                                                                        width:
                                                                                            "112px",
                                                                                        marginLeft:
                                                                                            "5px",
                                                                                    }}
                                                                                >
                                                                                    <b>
                                                                                        Summary
                                                                                    </b>
                                                                                </h5>
                                                                            </span>
                                                                            <span>
                                                                                <h5
                                                                                    style={{
                                                                                        fontSize:
                                                                                            "1em",
                                                                                        padding:
                                                                                            "7px",
                                                                                        textAlign:
                                                                                            "left",
                                                                                        width:
                                                                                            "206px",
                                                                                        marginLeft:
                                                                                            "5px",
                                                                                    }}
                                                                                >
                                                                                    <b>
                                                                                        Group
                                                                                        Status:
                                                                                    </b>{" "}
                                                                                    <span className="subHeading">
                                                                                        {
                                                                                            e.group_status
                                                                                        }
                                                                                    </span>
                                                                                </h5>
                                                                            </span>
                                                                            <span>
                                                                                <h5
                                                                                    style={{
                                                                                        fontSize:
                                                                                            "1em",
                                                                                        padding:
                                                                                            "7px",
                                                                                        textAlign:
                                                                                            "left",
                                                                                        width:
                                                                                            "206px",
                                                                                        marginLeft:
                                                                                            "5px",
                                                                                    }}
                                                                                >
                                                                                    <b>
                                                                                        Group
                                                                                        Mark:
                                                                                    </b>{" "}
                                                                                    <span className="subHeading">
                                                                                        {
                                                                                            e.group_mark
                                                                                        }
                                                                                    </span>
                                                                                </h5>
                                                                            </span>
                                                                            <span>
                                                                                <h5
                                                                                    style={{
                                                                                        fontSize:
                                                                                            "1em",
                                                                                        padding:
                                                                                            "7px",
                                                                                        textAlign:
                                                                                            "left",
                                                                                        width:
                                                                                            "300px",
                                                                                        marginLeft:
                                                                                            "5px",
                                                                                    }}
                                                                                >
                                                                                    <b>
                                                                                        Group
                                                                                        Outcome:
                                                                                    </b>{" "}
                                                                                    <span className="subHeading">
                                                                                        {
                                                                                            e.group_grade
                                                                                        }
                                                                                    </span>
                                                                                </h5>
                                                                            </span>
                                                                        </div>
                                                                    ) : (
                                                                        <div
                                                                            style={{
                                                                                display:
                                                                                    "flex",
                                                                                backgroundColor:
                                                                                    "yellow",
                                                                                color:
                                                                                    "black",
                                                                                marginBottom:
                                                                                    "5px",
                                                                            }}
                                                                        >
                                                                            <span>
                                                                                <h5
                                                                                    style={{
                                                                                        fontSize:
                                                                                            "1em",
                                                                                        padding:
                                                                                            "7px",
                                                                                        textAlign:
                                                                                            "left",
                                                                                        width:
                                                                                            "112px",
                                                                                        marginLeft:
                                                                                            "5px",
                                                                                    }}
                                                                                >
                                                                                    <b>
                                                                                        Summary
                                                                                    </b>
                                                                                </h5>
                                                                            </span>
                                                                            <span>
                                                                                <h5
                                                                                    style={{
                                                                                        fontSize:
                                                                                            "1em",
                                                                                        padding:
                                                                                            "7px",
                                                                                        textAlign:
                                                                                            "left",
                                                                                        width:
                                                                                            "206px",
                                                                                        marginLeft:
                                                                                            "5px",
                                                                                    }}
                                                                                >
                                                                                    <b>
                                                                                        Group
                                                                                        Status:
                                                                                    </b>{" "}
                                                                                    <span className="subHeading">
                                                                                        {
                                                                                            e.group_status
                                                                                        }
                                                                                    </span>
                                                                                </h5>
                                                                            </span>
                                                                            <span>
                                                                                <h5
                                                                                    style={{
                                                                                        fontSize:
                                                                                            "1em",
                                                                                        padding:
                                                                                            "7px",
                                                                                        textAlign:
                                                                                            "left",
                                                                                        width:
                                                                                            "206px",
                                                                                        marginLeft:
                                                                                            "5px",
                                                                                    }}
                                                                                >
                                                                                    <b>
                                                                                        Group
                                                                                        Mark:
                                                                                    </b>{" "}
                                                                                    <span className="subHeading">
                                                                                        {
                                                                                            e.group_mark
                                                                                        }
                                                                                    </span>
                                                                                </h5>
                                                                            </span>

                                                                            <span>
                                                                                <h5
                                                                                    style={{
                                                                                        fontSize:
                                                                                            "1em",
                                                                                        padding:
                                                                                            "7px",
                                                                                        textAlign:
                                                                                            "left",
                                                                                        width:
                                                                                            "300px",
                                                                                        marginLeft:
                                                                                            "5px",
                                                                                    }}
                                                                                >
                                                                                    <b>
                                                                                        Group
                                                                                        Outcome:
                                                                                    </b>{" "}
                                                                                    <span className="subHeading">
                                                                                        {
                                                                                            e.group_grade
                                                                                        }
                                                                                    </span>
                                                                                </h5>
                                                                            </span>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <div className="clear"></div>
                                                            </div>
                                                        </TableRow>
                                                    );
                                                })}
                                        </TableBody>
                                    </Table>
                                </div>
                            </ExpansionPanel>
                            <div
                                style={{
                                    clear: "both",
                                    border: "2px solid #0188cc",
                                    borderRadius: "6px",
                                    marginLeft: "5px",
                                    marginTop: "10px",
                                }}
                            >
                                <h1
                                    style={{
                                        backgroundColor: "#0188cc",
                                        textAlign: "center",
                                        padding: "4px",
                                        fontWeight: "bold",
                                        color: "white",
                                        fontSize: "22px",
                                    }}
                                >
                                    Inspection Summary
                                </h1>
                                {report.inspection_summary_result === "Pass" ? (
                                    <div
                                        style={{
                                            display: "flex",
                                            backgroundColor: "green",
                                            color: "white",
                                            height: "62px",
                                            paddingTop: "12px",
                                        }}
                                    >
                                        <span>
                                            <h5
                                                style={{
                                                    fontSize: "1em",
                                                    padding: "7px",
                                                    textAlign: "left",
                                                    width: "322px",
                                                    marginLeft: "5px",
                                                }}
                                            >
                                                <b>Inspection Outcome:</b>{" "}
                                                <span className="subHeading">
                                                    {
                                                        report.inspection_summary_result
                                                    }
                                                </span>
                                            </h5>
                                        </span>
                                        <span>
                                            <h5
                                                style={{
                                                    fontSize: "1em",
                                                    padding: "7px",
                                                    textAlign: "left",
                                                    width: "300px",
                                                    marginLeft: "5px",
                                                }}
                                            >
                                                <b>Inspection Percentage:</b>{" "}
                                                <span className="subHeading">
                                                    {
                                                        report.inspection_summary_percent
                                                    }
                                                </span>
                                            </h5>
                                        </span>
                                        <span>
                                            <h5
                                                style={{
                                                    fontSize: "1em",
                                                    padding: "7px",
                                                    textAlign: "left",
                                                    width: "300px",
                                                    marginLeft: "5px",
                                                }}
                                            >
                                                <b>Inspection Status:</b>{" "}
                                                <span className="subHeading">
                                                    {
                                                        report.inspection_summary_status
                                                    }
                                                </span>
                                            </h5>
                                        </span>
                                    </div>
                                ) : report.inspection_summary_result ===
                                  "Fail" ? (
                                    <div
                                        style={{
                                            display: "flex",
                                            backgroundColor: "#cc3f3f",
                                            color: "white",
                                            marginBottom: "5px",
                                            height: "62px",
                                            paddingTop: "12px",
                                        }}
                                    >
                                        <span>
                                            <h5
                                                style={{
                                                    fontSize: "1em",
                                                    padding: "7px",
                                                    textAlign: "left",
                                                    width: "322px",
                                                    marginLeft: "5px",
                                                }}
                                            >
                                                <b>Inspection Outcome:</b>{" "}
                                                <span className="subHeading">
                                                    {
                                                        report.inspection_summary_result
                                                    }
                                                </span>
                                            </h5>
                                        </span>
                                        <span>
                                            <h5
                                                style={{
                                                    fontSize: "1em",
                                                    padding: "7px",
                                                    textAlign: "left",
                                                    width: "300px",
                                                    marginLeft: "5px",
                                                }}
                                            >
                                                <b>Inspection Percentage:</b>{" "}
                                                <span className="subHeading">
                                                    {
                                                        report.inspection_summary_percent
                                                    }
                                                </span>
                                            </h5>
                                        </span>
                                        <span>
                                            <h5
                                                style={{
                                                    fontSize: "1em",
                                                    padding: "7px",
                                                    textAlign: "left",
                                                    width: "300px",
                                                    marginLeft: "5px",
                                                }}
                                            >
                                                <b>Inspection Status:</b>{" "}
                                                <span className="subHeading">
                                                    {
                                                        report.inspection_summary_status
                                                    }
                                                </span>
                                            </h5>
                                        </span>
                                    </div>
                                ) : (
                                    <div
                                        style={{
                                            display: "flex",
                                            backgroundColor: "yellow",
                                            color: "black",
                                            marginBottom: "5px",
                                            height: "62px",
                                            paddingTop: "12px",
                                        }}
                                    >
                                        <span>
                                            <h5
                                                style={{
                                                    fontSize: "1em",
                                                    padding: "7px",
                                                    textAlign: "left",
                                                    width: "332px",
                                                    marginLeft: "5px",
                                                }}
                                            >
                                                <b>Inspection Outcome:</b>{" "}
                                                <span className="subHeading">
                                                    {
                                                        report.inspection_summary_result
                                                    }
                                                </span>
                                            </h5>
                                        </span>
                                        <span>
                                            <h5
                                                style={{
                                                    fontSize: "1em",
                                                    padding: "7px",
                                                    textAlign: "left",
                                                    width: "300px",
                                                    marginLeft: "5px",
                                                }}
                                            >
                                                <b>Inspection Percentage:</b>{" "}
                                                <span className="subHeading">
                                                    {
                                                        report.inspection_summary_percent
                                                    }
                                                </span>
                                            </h5>
                                        </span>
                                        <span>
                                            <h5
                                                style={{
                                                    fontSize: "1em",
                                                    padding: "7px",
                                                    textAlign: "left",
                                                    width: "300px",
                                                    marginLeft: "5px",
                                                }}
                                            >
                                                <b>Inspection Status:</b>{" "}
                                                <span className="subHeading">
                                                    {
                                                        report.inspection_summary_status
                                                    }
                                                </span>
                                            </h5>
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    {report && (
                        <Modal isOpen={this.state.imageModal}>
                            <ModalHeader>Image Details</ModalHeader>
                            <ModalBody style={{ margin: "auto" }}>
                                <img
                                    src={
                                        this.state.selectedImg
                                            ? this.state.selectedImg
                                            : noImg
                                    }
                                    alt="Site"
                                    style={{ width: "350px", height: "350px" }}
                                />
                            </ModalBody>
                            <ModalFooter>
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        this.setState({
                                            selectedImg: "",
                                            imageModal: false,
                                        });
                                    }}
                                >
                                    Close
                                </Button>
                            </ModalFooter>
                        </Modal>
                    )}
                </CardContent>
            </Card>
        );
    }
}

export default connect(
    (store) => {
        return {
            report: selectCurrentReport(store),
        };
    },
    { getReport, getStandaloneReport }
)(CustomReport);
